module.exports = __webpack_public_path__ + "img/tarjeta_ofertas_trae_un_amigo.dc33a589.jpg";